// Initialize theme object
window.theme = window.theme || {};

import '../scripts/utils/helpers';
import '../scripts/components/product-gallery-enhanced';
import '../scripts/components/inquiry-drawer';
import '../scripts/components/inquiry-drawer-v2';
import '../scripts/components/photoswipe-enhanced';
import '../scripts/components/password-overlay';
import '../scripts/components/variant-content-toggler';
import '../scripts/components/text-animations';
import '../scripts/components/image-popup';
import '../scripts/components/event-popup';
import { initEmailValidation } from '../scripts/utils/emailValidator';

console.log('main.bundle.js loaded');

// Initialize email validation
initEmailValidation();

// Dispatch event when theme bundle is loaded
document.dispatchEvent(new CustomEvent('theme:loaded'));
window.theme.loaded = true;